import React from 'react';

import { ClaimsFormStatus } from 'Containers/ProfilePage/types';
import { ClaimsCard } from 'ContentfulDefaults/types/profile';
import InfoBar from 'DesignLibrary/molecules/InfoBar';

export interface ClaimsSectionInfoBarProps {
  status: ClaimsFormStatus;
  contentfulCard: ClaimsCard;
}

export const ClaimsSectionInfoBar = ({ status, contentfulCard }: ClaimsSectionInfoBarProps) => {
  const renderInfoBar = () => {
    switch (status) {
      case ClaimsFormStatus.Submitted:
      case ClaimsFormStatus.Loading:
        return (
          <InfoBar
            data-testid="claims-submitted-message"
            text={contentfulCard.submitted_message}
            icon="BellRinging"
            color="blue"
          />
        );
      case ClaimsFormStatus.Success:
        return (
          <InfoBar
            data-testid="claims-success-message"
            text={contentfulCard.success_message}
            icon="CheckCircle"
            color="green"
          />
        );
      case ClaimsFormStatus.Failure:
        return (
          <InfoBar
            data-testid="claims-failure-message"
            text={contentfulCard.error_message}
            icon="Warning"
            color="red"
          />
        );
      default:
        return null;
    }
  };

  return renderInfoBar();
};
